// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs {
  display: none;
  padding: 3vw 5vw 2vw;
  background: transparent;
  font-family: "Satoshi", sans-serif;
  position: relative;
  z-index: 10;
}

.breadcrumbs-container {
  display: flex;
  align-items: center;
  gap: 1vw;
  font-size: 3.5vw;
  color: #ffffff;
}

.breadcrumbs-home {
  color: #CCFF00;
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.breadcrumbs-separator {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0.5vw;
}

.breadcrumbs-link {
  color: #CCFF00;
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.breadcrumbs-link:hover {
  opacity: 0.8;
}

.breadcrumbs-current {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  /* Truncate long article titles */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 50vw;
}

/* Show breadcrumbs only on mobile */
@media (max-width: 768px) {
  .breadcrumbs {
    display: block;
  }
}

`, "",{"version":3,"sources":["webpack://./src/component/breadcrumbs/breadcrumbs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".breadcrumbs {\n  display: none;\n  padding: 3vw 5vw 2vw;\n  background: transparent;\n  font-family: \"Satoshi\", sans-serif;\n  position: relative;\n  z-index: 10;\n}\n\n.breadcrumbs-container {\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n  font-size: 3.5vw;\n  color: #ffffff;\n}\n\n.breadcrumbs-home {\n  color: #CCFF00;\n  text-decoration: none;\n  font-weight: 500;\n  transition: opacity 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.breadcrumbs-separator {\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0 0.5vw;\n}\n\n.breadcrumbs-link {\n  color: #CCFF00;\n  text-decoration: none;\n  font-weight: 500;\n  transition: opacity 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.breadcrumbs-link:hover {\n  opacity: 0.8;\n}\n\n.breadcrumbs-current {\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  /* Truncate long article titles */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 50vw;\n}\n\n/* Show breadcrumbs only on mobile */\n@media (max-width: 768px) {\n  .breadcrumbs {\n    display: block;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
